<!-- 仓库主数据 -->
<template>
  <div class="store" id="test1----">
    <sirui-search
      ref="storeDataSearch"
      :query="query"
      :columns="searchFormColumns"
      labelWidth="125px"
      :defaultRow="2"
      @changeCompanyHandler="changeCompanyHandler"
      @changeDepartmentHandler="changeDepartmentHandler"
      @resetBtnClick="resetBtnClickHandler"
      @searchBtnClick="queryBtnClickHandler"
      @changeProject="changeProject"
      @changePerson="changePerson"
    ></sirui-search>
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :showFooter="true"
        :footerMethod="footerMethod"
        :buttonList="menuButtonList"
        :loading="loading"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          type="seq"
          width="50"
          title="序号"
          v-if="columnList.length"
        ></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
          <template v-slot="{ row }">
            <template v-if="item.field === 'expenseType'">{{
              expenseTypeList?.find((item) => item.value == row['expenseType'])?.label
            }}</template>
            <template v-else-if="item.field === 'unit'">{{
              basic_unit?.find((item) => item.value == row['unit'])?.label
            }}</template>
            <template v-else-if="item.field === 'processStatus'">{{
              row.processStatus == '0' ? '未处理' : '已处理'
            }}</template>
            <template v-else-if="item.field === 'createMethod'">{{
              row.createMethod == '01' ? '系统' : '手动'
            }}</template>
            <!-- <template v-else-if="item.field === 'statementQuantity'">{{
              row.statementQuantity | formateQuantityToWumao(isWuMaoAccount)
            }}</template> -->

            <template v-else-if="item.field === 'paymentStatus'">{{
              row.paymentStatus == '01'
                ? '已付款'
                : row.paymentStatus == '02'
                ? '未付款'
                : '部分付款'
            }}</template>
            <!-- <template v-else-if="item.field === 'isLock'">{{
              row.isLock == '0' ? '未锁定' : '锁定'
            }}</template> -->
            <template v-else-if="item.field === 'isIndividualPartner'">{{
              row.isIndividualPartner == '0' ? '否' : '是'
            }}</template>
            <template v-else-if="['originalPrice', 'statementQuantity'].includes(item.field)">
              {{ replaceLastZeroStr(row[item.field]) }}
            </template>
            <template
              v-else-if="
                ['originalAmount', 'domesticAmount', 'paidAmount', 'unpaidAmount'].includes(
                  item.field
                )
              "
            >
              {{ $utils.commafy($utils.toNumber(replaceZeroStr(row[item.field])), { digits: 2 }) }}
            </template>
            <template v-else>{{ row[item.field] }}</template>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import PAYABLES_TRADE from '@/api/receivablesAndPayables/trade.js';
  import { searchColumns, defaultTableColumn } from './index.js';
  // defaultMenuBtnList
  import expenseListMixin from './index.js';
  export default {
    mixins: [expenseListMixin],
    name: 'trade',
    components: {
      SiruiSearch,
      SiruiTable,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        lang: (state) => state.lang.language,
      }),
      searchFormColumns() {
        return searchColumns(this);
      },
      basic_unit() {
        return this.dictListMap.basic_unit;
      },
    },
    mounted() {
      // this.getTableData();
      this.getButtonList();
      this.query = {
        ...this.query,
        ...{
          personIds: [this.userInfo.userCode],
          personNames: this.userInfo.userName,
        },
      };
      if (this.$route.query?.contractNo) {
        this.query.contractNo = this.$route.query?.contractNo;
        this.query.processStatus = this.$route.query?.processStatus.toString();
      }
    },
    data() {
      return {
        loading: false,
        handleRejectValue: '',
        menuButtonList: [], // 表格功能按钮
        multipleSelection: [], // 表格被选中的行数据
        tableData: [], // 表格数据
        importUrl: '',
        importData: {},
        columnList: [],
        query: {
          pageNum: 1,
          pageSize: 10,
          businessCompanyNo: '',
          businessDepartmentCode: '',
          processStatus: null,
          expenseType: '',
          businessCategory: '01',
          accountPeriod: '',
          periodDateFrom: '',
          periodDateUntil: '',
          supplierNo: '',
          vehicleNo: '',
          projectInitiationNoLike: '',
          projectNameLike: '',
          baseNameLike: '',
          expenseNoLike: '',
          businessDateStart: '',
          businessDateEnd: '',
          originalTotalAmountStart: '',
          originalTotalAmountEnd: '',
          contractNo: '',
          delivererNo: '',
          paymentStatus: '',
          // isLock: '',
          salesmanNo: '',
          personIds: [],
          personNames: '',
        },
        companyCode: null,
      };
    },
    // watch: {
    //   // $route() {
    //   //   this.query = {
    //   //     pageNum: 1,
    //   //     pageSize: 10,
    //   //     businessCompanyNo: '',
    //   //     businessDepartmentCode: '',
    //   //     processStatus: null,
    //   //     expenseType: '',
    //   //     businessCategory: '01',
    //   //     accountPeriod: '',
    //   //     periodDateFrom: '',
    //   //     periodDateUntil: '',
    //   //     supplierNo: '',
    //   //     vehicleNo: '',
    //   //     projectInitiationNoLike: '',
    //   //     projectNameLike: '',
    //   //     baseNameLike: '',
    //   //     expenseNoLike: '',
    //   //     businessDateStart: '',
    //   //     businessDateEnd: '',
    //   //     originalTotalAmountStart: '',
    //   //     originalTotalAmountEnd: '',
    //   //     contractNo: '',
    //   //     delivererNo: '',
    //   //     salesmanNo: '',
    //   //   };
    //   //   this.multipleSelection = [];
    //   //   this._getCompanyApi();
    //   //   this.getButtonList();
    //   // },
    // },
    methods: {
      changePerson({ val, prop }) {
        console.log(val, prop, '==');
        if (prop == 'personNames') {
          const rowData = val && Array.isArray(val) && val.length ? val : [];
          this.query.personNames = rowData.map((item) => item.personName).join(',');
          this.query.personIds = rowData.map((item) => item.id).filter((item) => Boolean(item));
        }
      },
      changeProject({ val, prop }) {
        console.log(val, prop, '==');
        if (prop == 'projectNameLike') {
          const rowData = val && Array.isArray(val) && val.length ? val[0] : {};
          this.query.projectNameLike = rowData.projectAbbreviation || rowData.projectName || '';
          this.query.projectInitiationNoLike = rowData.projectInitiationNo || '';
        }
      },
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            if (['originalAmount'].includes(column.property)) {
              return Number(
                data.reduce((cur, next) => cur + +next.originalAmount, 0).toFixed(2)
              ).toLocaleString('en-us');
            } else if (['domesticAmount'].includes(column.property)) {
              return Number(
                data.reduce((cur, next) => cur + +next.domesticAmount, 0).toFixed(2)
              ).toLocaleString('en-us');
            } else if (['statementQuantity'].includes(column.property)) {
              return Number(
                data
                  .reduce((cur, next) => cur + +next.statementQuantity, 0)
                  .toFixed(this.isWuMaoAccount ? 8 : 2)
              );
            }
            return null;
          }),
        ];
      },
      // 计算选中金额
      _computedAmount(selection) {
        console.log(selection);
        const originalAmount = selection.reduce((prev, cur) => prev + +cur.originalAmount, 0);
        const domesticAmount = selection.reduce((prev, cur) => prev + +cur.domesticAmount, 0);
        const allTdDom = document.querySelector('.vxe-footer--row').querySelectorAll('td');
        const totalDom1 = allTdDom[4];
        const totalDom2 = allTdDom[6];
        totalDom1.querySelector('.vxe-cell').innerHTML = originalAmount.toFixed(2);
        totalDom2.querySelector('.vxe-cell').innerHTML = domesticAmount.toFixed(2);
      },
      // // 切换公司
      // changeCompanyHandler(val, partnerZhName1) {
      //   console.log(val, '切换公司', partnerZhName1);
      //   this.companyCode = val.val;
      //   this.query.businessDepartmentCode = null;
      // },
      // 切换供应商
      changeSupplyChainMethod(val) {
        this.query.supplierNo = val[0].partnerCode;
        console.log(val, '修改供应商');
      },
      // 修改合同
      changeContractMethod(val) {
        this.query.contractNo = val[0].contractNo;
        console.log(val, '修改合同');
      },
      // 修改投送人
      changeDelivererNameMethod(val) {
        this.query.delivererNo = val[0]?.personNo || '';
      },
      // 修改业务员
      changeSalesmanNoMethod(val) {
        this.query.salesmanNo = val[0]?.personNo || '';
      },

      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          // TODO 后端还没处理好返回数据，前端先这样处理
          // this.menuButtonList = e.length > 0 ? e : defaultMenuBtnList;
          this.menuButtonList = e.length > 0 ? e : [];
          console.log(e, '查看按钮列表');
          this.getColumnInfo();
        });
      },
      //获取当前列
      getColumnInfo() {
        this.getColumnList(defaultTableColumn).then(() => {
          // console.log(11111);
          this.columnList = defaultTableColumn;
        });
      },
      // 获取表格数据
      async getTableData(search) {
        console.log(search, '搜索');
        this.loading = true;
        const postData = {
          ...this.query,
          processStatus: this.query.processStatus == null ? null : +this.query.processStatus,
          pageNum: this.$refs.siruiTable.page.pageNum,
          pageSize: this.$refs.siruiTable.page.pageSize,
          businessGroup: this.userInfo.businessGroup,
        };
        const { data } = await this.$axios.post(PAYABLES_TRADE.PAYABLEEXPENSE_QUERY, postData);
        this.loading = false;
        this.tableData = data.data.records;
        this.tableData.forEach((item) => {
          item.domesticAmount = item.domesticAmount.toFixed(2);
          item.originalAmount = item.originalAmount.toFixed(2);
        });
        console.log(data.data.records, 'data.data.records');

        this.$refs.siruiTable.setPageTotal(data.data.total);
      },
      // 表格上面的按钮
      async chooseClick(type) {
        console.log(type, '点击按钮操作');
        if (type == 'create') {
          // TODO 判断必须要选择行才可以跳转
          const selectedList = this.multipleSelection;
          if (!selectedList.length) {
            this.$message.error('请选择行操作');
            return;
          }

          let processStatusList = selectedList.filter((item) => item.processStatus == '1');
          console.log(processStatusList, 'processStatusList');
          if (processStatusList.length > 0) {
            this.$message.error('已处理的费用清单不能再次创建');
            return;
          }
          let inboundBatchNos = [];
          selectedList.map((item) => {
            inboundBatchNos.push(item.businessDocCode);
          });
          const { data } = await this.$axios.post(
            PAYABLES_TRADE.PAYBLES_CHECKLOCKSTATUS_API,
            inboundBatchNos
          );
          // PAYBLES_CHECKLOCKSTATUS_API
          if (data.code !== 0) {
            this.$message.error(`${data.msg}`);
            return;
          }
          let productNameList = [];
          let productNameStatus = null;
          let contractNoList = [];
          let contractNoStatus = null;
          let projectInitiationNoList = [];
          let projectInitiationNoStatus = null;
          let ids = [];
          let isIndividualPartnerList = [];
          let supplierNameList = [];
          let settlementTypeStatus = null;
          let settlementTypeList = [];
          selectedList.map((item) => {
            productNameList.push(item.productName);
            contractNoList.push(item.contractNo);
            projectInitiationNoList.push(item.projectInitiationNo);
            ids.push(+item.id);
            isIndividualPartnerList.push(item.isIndividualPartner);
            supplierNameList.push(item.supplierName);
            settlementTypeList.push(item.settlementType);
          });
          projectInitiationNoStatus = this.isAllEqual(projectInitiationNoList);
          if (!projectInitiationNoStatus) {
            this.$message.error('所选项目名称不一致');
            return;
          }
          productNameStatus = this.isAllEqual(productNameList);
          contractNoStatus = this.isAllEqual(contractNoList);
          if (!productNameStatus || !contractNoStatus) {
            this.$message.error('所选合同或商品名称不一致');
            return;
          }
          settlementTypeStatus = this.isAllEqual(settlementTypeList);
          if (!settlementTypeStatus) {
            this.$message.error('所选结算类型不一致');
            return;
          }
          // console.log(productNameList, 'productNameList');
          // console.log(productNameStatus, 'productNameStatus');
          // console.log(contractNoList, 'contractNoList');
          // console.log(contractNoStatus, 'contractNoStatus');
          // let uniquePartner =
          //   [...new Set(isIndividualPartnerList)].length > 1 ? '' : isIndividualPartnerList[0];
          // let uniqueSupplierName =
          //   [...new Set(supplierNameList)].length > 1 ? '' : supplierNameList[0];
          // if (uniquePartner == '0') {
          //   if (!productNameStatus || !contractNoStatus) {
          //     this.$message.error('所选合同或商品名称不一致');
          //     return;
          //   } else {
          //     this.jumpHandler(ids);
          //   }
          // } else if (uniquePartner == '1') {
          //   if (uniqueSupplierName) {
          //     this.jumpHandler(ids);
          //   } else {
          //     this.$message.error('所选供应商不一致');
          //     return;
          //   }
          // } else {
          //   this.$message.error('所选供应商不一致');
          //   return;
          // }
          this.jumpHandler(ids);
        } else if (type == 'export') {
          const selectedList = this.multipleSelection;
          if (selectedList.length > 0) {
            const postData = [];
            selectedList.map((item) => {
              postData.push(item.id);
            });
            const { data } = await this.$axios.post(PAYABLES_TRADE.PAYABLEEXPENSE_EXPORT, {
              businessCategory: this.query?.businessCategory,
              ids: postData,
            });
            if (data.code === 0) {
              window.location.href = data.data;
              this.$message.success('导出成功');
            } else {
              this.$message.error(`${data.msg}`);
            }
          } else {
            const postData = this.query;
            const { data } = await this.$axios.post(PAYABLES_TRADE.PAYABLEEXPENSE_EXPORT, postData);
            if (data.code === 0) {
              window.location.href = data.data;
              this.$message.success('导出成功');
            } else {
              this.$message.error(`${data.msg}`);
            }
          }
        }
      },
      jumpHandler(ids) {
        let path = {
          path: '/receivablesAndPayables/tradePayablesDetail',
          name: 'tradePayablesDetail',
          meta: {
            keepAlive: true,
            title: '贸易应付结算单',
          },
          query: {
            status: 'create',
            id: ids,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //判断数组里元素是否全相等
      isAllEqual(array) {
        if (array.length > 0) {
          return !array.some(function (value) {
            return value !== array[0];
          });
        } else {
          return true;
        }
      },

      // 表格选择行
      handleSelectionChange(row) {
        console.log(row);
        this.multipleSelection = row;
        this._computedAmount(row);
      },
      // 搜索
      queryBtnClickHandler() {
        console.log('搜索', this.query);
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this._computedAmount([]);
        this.getTableData();
      },
      // 重置
      resetBtnClickHandler() {
        this.query.projectNameLike = '';
        this.query.projectInitiationNoLike = '';
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this._getDepartmentByCompanyCodeApi(this.userInfo.companyCode);
        this.query = {
          ...this.query,
          businessCompanyNo: this.userInfo.companyCode,
          businessCompanyName: this.userInfo.companyName,
          businessDepartmentCode: this.userInfo?.departmentCode,
          businessDepartmentName: this.userInfo?.departmentName,
        };
        this._computedAmount([]);
        this.getTableData();
      },
      // 修改每页条数
      handleSizeChange() {
        this.$refs.siruiTable.setPageNum(1);
        this.getTableData();
      },
      // 修改当前页
      handleCurrentChange() {
        this.getTableData();
      },
    },
    watch: {
      $route(val) {
        if (val.query?.contractNo) {
          this.query.contractNo = val.query?.contractNo;
          this.query.processStatus = val.query?.processStatus.toString();
          this.getTableData();
        }
      },
    },
  };
</script>

<style lang="scss" scoped></style>
